import api from './api';

// Get all exams
export const getExams = async (filters = {}) => {
  const params = new URLSearchParams(filters);
  const response = await api.get(`/exams?${params}`);
  return response.data;
};

// Get single exam
export const getExamById = async (id) => {
  const response = await api.get(`/exams/${id}`);
  return response.data;
};

// Create exam
export const createExam = async (examData) => {
  const response = await api.post('/exams', examData);
  return response.data;
};

// Update exam
export const updateExam = async (id, examData) => {
  const response = await api.put(`/exams/${id}`, examData);
  return response.data;
};

// Delete exam
export const deleteExam = async (id) => {
  const response = await api.delete(`/exams/${id}`);
  return response.data;
};

// Get exam statistics
export const getExamStats = async (filters = {}) => {
  const params = new URLSearchParams(filters);
  const response = await api.get(`/exams/stats?${params}`);
  return response.data;
};
